export default __webpack_public_path__ + "static/media/PP-DM.dfa9a1ef.pdf";